import React from "react";
import { Collapse, Table, Input } from "antd";

const { Panel } = Collapse;

const ItemEstimationAndStock = ({
  itemsEstimation = [],
  mailStockData = [],
  handleQtyChange,
  panelHeaderExtra,
  disabled, // Add disabled prop
}) => {
  const columns = [
    {
      title: "Item Description",
      dataIndex: "offer_item_description",
      key: "offer_item_description",
      align: "center",
    },
    {
      title: "Qty per Order",
      dataIndex: "qtyPerOrder",
      key: "qtyPerOrder",
      align: "center",
      render: (value, row, index) => (
        <Input
          type="number"
          step={0.1}
          min={0}
          value={value}
          onChange={(e) => handleQtyChange(index, parseFloat(e.target.value))}
          style={{ width: 80 }}
          disabled={disabled} // Respect the disabled prop
        />
      ),
    },
    {
      title: "Total Qty",
      dataIndex: "totalQty",
      key: "totalQty",
      align: "center",
      render: (value) => (value != null ? value : 0),
    },
    {
      title: "Stock on Mail Date",
      dataIndex: "stock",
      key: "stock",
      align: "center",
      render: (value, row) => {
        const stock =
          mailStockData.find(
            (item) => item.variation === row.offer_item_description
          )?.stock ?? 0;
        return stock;
      },
    },
    {
      title: "Difference",
      key: "difference",
      align: "center",
      render: (_, row) => {
        const stock =
          mailStockData.find(
            (item) => item.variation === row.offer_item_description
          )?.stock ?? 0;
        const totalQty = parseFloat(row.totalQty) || 0;
        const diff = stock - totalQty;
        return (
          <span
            style={{
              color: diff >= 0 ? "#52c41a" : "#ff4d4f",
              fontWeight: 500,
            }}
          >
            {diff}
          </span>
        );
      },
    },
  ];

  const dataSource =
    itemsEstimation?.map((row, index) => ({
      ...row,
      key: index,
      stock:
        mailStockData.find(
          (item) => item.variation === row.offer_item_description
        )?.stock ?? 0,
    })) || [];

  return (
    <Collapse
      defaultActiveKey={["1"]}
      style={{ marginBottom: 16 }}
      bordered={false}
    >
      <Panel
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span>Item Estimations & Stock</span>
            {panelHeaderExtra && <span>{panelHeaderExtra}</span>}
          </div>
        }
        key="1"
      >
        <Table
          bordered
          size="small"
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          className="small-font"
        />
      </Panel>
    </Collapse>
  );
};

export default ItemEstimationAndStock;
